var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76051 12.7497C11.1488 13.4438 12.3388 14.4922 13.203 15.7955C13.6988 16.5322 13.6988 17.4813 13.203 18.218C12.3388 19.5072 11.1488 20.5555 9.76051 21.2497M18.4163 21.2497H24.083M12.7497 31.1663H21.2497C28.333 31.1663 31.1663 28.333 31.1663 21.2497V12.7497C31.1663 5.66634 28.333 2.83301 21.2497 2.83301H12.7497C5.66634 2.83301 2.83301 5.66634 2.83301 12.7497V21.2497C2.83301 28.333 5.66634 31.1663 12.7497 31.1663Z",
    stroke: "#005B98",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/Code.5c784d876da1f343d0338e0e6615f507.svg";
export { ForwardRef as ReactComponent };